export default {
    data() {
        return {
            logs_id: '',
            latest_log_id: '',
            auto_logout_timer: 0,
            isRunning: false,
            interval: null

        }
    },
    mounted(){

    },
    methods: {
        $toggleTimer(){

            if (this.isRunning) {
                clearInterval(this.interval);
            }else{
                this.interval = setInterval(this.$incrementTime, 1000);
            }

            this.isRunning = !this.isRunning;
        },
        $resetTimer: async function(){
            let auto_logout_timer = Number(localStorage.getItem("auto_logout_timer"));
            let triggered_refresh =  localStorage.getItem("triggered_refresh");
            let vm = this;
            let mins = 15;
            if(auto_logout_timer < (mins * 60)){
                localStorage.setItem("auto_logout_timer",0)
            }else if(triggered_refresh == 'false'){
                await localStorage.setItem("triggered_refresh",'true');
                const token = localStorage.getItem('user') ;
                const token_data = JSON.parse ( token ) ;

                if(token_data.user.name == 'OTPM ADMIN'){
                    return '';
                }

                let formData = new FormData();
                formData.append('refresh_token', token_data.refresh_token);
                formData.append('email', token_data.user.email);
                let authHeader = {headers: { 'Authorization' : 'Bearer '+ token_data.access_token}};

                await axios.post( '/api/revoke_token',formData,authHeader ).then(response =>{
                    if(response.status === 200){
                        this.$swal.fire({
                            title: "Session Expired",
                            text: 'Your session has been expired, Please re-login',
                            icon: 'warning',
                            showConfirmButton: true,
                            onClose: () => {
                                localStorage.removeItem( 'user-info' ) ;
                                localStorage.removeItem( 'user' ) ;
                                localStorage.removeItem("permissions");
                                localStorage.removeItem("roles");
                                localStorage.removeItem("expires_at");
                                localStorage.removeItem("refresh_expires_at");
                                localStorage.removeItem("triggered_refresh");
                                vm.$router.go();
                            }
                        });
                    }
                });

                console.log('revoke');
            }


        },
        $incrementTime() {
            let auto_logout_timer = Number(localStorage.getItem("auto_logout_timer"));
            auto_logout_timer = parseInt(auto_logout_timer) + 1;
            localStorage.setItem("auto_logout_timer",auto_logout_timer);

            this.auto_logout_timer = auto_logout_timer;
        },
        $getUserToken: async function (email) {
            let uri = `/api/getUserToken?email=${email}`;
            const token = localStorage.getItem('user') ;
            const token_data = JSON.parse ( token ) ;
            let authHeader = {headers: { 'Authorization' : 'Bearer '+ token_data.access_token}};
            axios.get(uri,authHeader).then(response=>{
                localStorage.setItem("expires_at", response.data.expires_at);
                localStorage.setItem("refresh_expires_at", response.data.refresh_expires_at);
                localStorage.setItem("triggered_refresh",'false');
                localStorage.setItem('user-info', JSON.stringify(response.data));

                let userInfo = JSON.parse(localStorage.getItem("user"));
                localStorage.removeItem( 'user' ) ;
                let newPerm = [];
                for(const nPermission of response.data.permissions){
                    newPerm.push(nPermission.name);
                }
                userInfo.permissions = newPerm;
                // console.log('test',userInfo);
                localStorage.setItem("user",JSON.stringify(userInfo));
            });


        },
        $refresh: async function () {
            const token = localStorage.getItem('user') ;
            const token_data = JSON.parse ( token ) ;

            let formData = new FormData();
            formData.append('refresh_token', token_data.refresh_token);
            formData.append('email', token_data.user.email);

            let authHeader = {headers: { 'Authorization' : 'Bearer '+ token_data.access_token}};
            await axios.post( '/api/refresh',formData,authHeader ).then(response =>{
                if(response.status === 200){
                    // localStorage.setItem('user-info', JSON.stringify(response.data));
                    localStorage.setItem("user",JSON.stringify(response.data));
                }
            });
            await this.$getUserToken(token_data.user.email);
            await this.$resetTimer();
            console.log('refreshtoken');
        },
        async $mouseMove(event) {
            let timeNow = this.$moment().format("yyyy-MM-D HH:mm:ss");
            let refreshExpiresAt = localStorage.getItem("refresh_expires_at");
            let currentUser =  localStorage.getItem("user");
            let triggered_refresh =  localStorage.getItem("triggered_refresh");
            let localRefreshExpiresAt = this.$moment(refreshExpiresAt).format("yyyy-MM-DD HH:mm:ss");
            let vm = this;
            if(timeNow > localRefreshExpiresAt && localRefreshExpiresAt != null){
                this.$swal.fire({
                    title: "Session Expired",
                    text: 'Your session has been expired, Please re-login',
                    icon: 'warning',
                    showConfirmButton: true,
                    onClose: () => {
                        localStorage.removeItem( 'user-info' ) ;
                        localStorage.removeItem( 'user' ) ;
                        localStorage.removeItem("permissions");
                        localStorage.removeItem("roles");
                        localStorage.removeItem("expires_at");
                        localStorage.removeItem("refresh_expires_at");
                        localStorage.removeItem("triggered_refresh");
                        vm.$router.go();
                    }
                });
                return;
            }

            if(currentUser){
                let localExpiresAt = await localStorage.getItem('expires_at');
                if(localExpiresAt == null || triggered_refresh == 'true'){
                    return;
                }
                let expireAt = this.$moment(localExpiresAt).format("yyyy-MM-DD HH:mm:ss");
                if(timeNow > expireAt && triggered_refresh === 'false'){
                    await localStorage.setItem("triggered_refresh",'true');
                    await this.$refresh();
                }
            }
        }
    },
};
